RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _) {

    'use strict';

    function sourceRenderer(item) {
        const sourceTemplate = Marionette.TemplateCache.get('#favoritesChannelOptionTemplate');

        if (item.source === RivalIQ.enums.sources.LINKEDIN) {
            item.name = 'LinkedIn Analytics';
        }

        return sourceTemplate(item);
    }

    selectors.Source = RivalIQ.views.Select.extend({
        name: 'source',
        valueField: 'source',
        itemRenderer: sourceRenderer,

        onChange: function (source) {
            const me = this;

            if (me.dashboardModel) {
                const metric = me.dashboardModel.baseMetric;

                const channel = RivalIQ.data.channels.get(source);
                let channelName = channel.get('channel');
                if (channel.isCrossChannel()) {
                    channelName = undefined;
                }

                metric.channel = channelName;
                me.dashboardModel.setProps({
                    metrics: me.dashboardModel.getProp('defaultMetrics'),
                    channel: metric.channel
                }, {
                    silent: true,
                    navigate: false
                });

                me.dashboardModel.setBaseMetric(metric);
            }
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);

            if (me.disabled) {
                me.items = [RivalIQ.data.channels.get(me.selected).toJSON()];
            } else if (me.dashboardModel) {
                me.selected = me.dashboardModel.getProp('source');
                me.items = me.dashboardModel.getValidChannels().toJSON();
            } else if (!me.items) {
                me.items = RivalIQ.data.channels.forAnalyze().withAccess().notHidden(true).toJSON();
            }
        }
    });
});
